// CONST
import ROUTES from "./routesContants"

// Pages
import * as actions from "./page-groups/actions"
import * as activityLogsPages from "./page-groups/activity_log"
import * as admin from "./page-groups/administration"
import * as auditLog from "./page-groups/audit_log"
import * as appointmentsPages from "./page-groups/appointments"
import * as blocksPages from "./page-groups/blocks"
import * as calendarPages from "./page-groups/calendar_pages"
import * as customDataFormPages from "./page-groups/custom_data_forms"
import * as enterprisePages from "./page-groups/enterprise"
import * as generalPages from "./page-groups/general_page"
import * as groupSessionPages from "./page-groups/group_session"
import * as groupSupervisionSessionsPages from "./page-groups/group_supervision_sessions"
import * as libraryPages from "./page-groups/library"
import * as locationPages from "./page-groups/location"
import * as organizationPages from "./page-groups/organization"
import * as participants from "./page-groups/participant"
import * as partnerPages from "./page-groups/partner"
import * as programPages from "./page-groups/program"
import * as referralsPages from "./page-groups/referrals"
import * as shelledTemplates from "./page-groups/shelled_templates"
import * as account from "./page-groups/account"
import * as staff from "./page-groups/staff"
import * as supervisionPlansPages from "./page-groups/supervision_plans"
import * as supervisionSessionPages from "./page-groups/supervision_session_list"
import * as templatePages from "./page-groups/template"
import * as user from "./page-groups/user"
import * as defaultPages from "./page-groups/default_pages"
//GPRA
import RecordMgmt from "../../pages/GPRAForms/Forms/A/RecordMgmt/RecordMgmt"
import Start from "../../pages/GPRAForms/Forms/A/Start/Start"
import PlannedServices1Container from "../../pages/GPRAForms/Containers/PlannedServices1Container"
import PlannedServices2Container from "../../pages/GPRAForms/Containers/PlannedServices2Container"
import PlannedServices3Container from "../../pages/GPRAForms/Containers/PlannedServices3Container"
import PlannedServices4Container from "../../pages/GPRAForms/Containers/PlannedServices4Container"
import DemographicsContainer from "../../pages/GPRAForms/Containers/DemographicsContainer"
import SubstanceUse1Container from "../../pages/GPRAForms/Containers/SubstanceUse1Container"
import SubstanceUse2Container from "../../pages/GPRAForms/Containers/SubstanceUse2Container"
import SubstanceUse3Container from "../../pages/GPRAForms/Containers/SubstanceUse3Container"
import FamilyContainer from "../../pages/GPRAForms/Containers/FamilyContainer"
import EducationContainer from "../../pages/GPRAForms/Containers/EducationContainer"
import LegalContainer from "../../pages/GPRAForms/Containers/LegalContainer"
import MentalContainer from "../../pages/GPRAForms/Containers/MentalContainer"
import SocialContainer from "../../pages/GPRAForms/Containers/SocialContainer"
import ProgramQuestionsContainer from "../../pages/GPRAForms/Containers/ProgramQuestionsContainer"
import FollowUpContainer from "../../pages/GPRAForms/Containers/FollowUpContainer"
import DischargeContainer from "../../pages/GPRAForms/Containers/DischargeContainer"
import ServicesReceived1Container from "../../pages/GPRAForms/Containers/ServicesReceived1Container"
import ServicesReceived2Container from "../../pages/GPRAForms/Containers/ServicesReceived2Container"
import ServicesReceived3Container from "../../pages/GPRAForms/Containers/ServicesReceived3Container"
import ServicesReceived4Container from "../../pages/GPRAForms/Containers/ServicesReceived4Container"
import ServicesReceived5Container from "../../pages/GPRAForms/Containers/ServicesReceived5Container"
import GPRAForms from "../../pages/GPRAForms"
import Summary from "../../pages/GPRAForms/Forms/Summary/Summary"
import GlobalMessages from "../../pages/TelerecoveryServices/GlobalMessages/index"
import CoordinationBoards from "../../pages/CoordinationBoards"
import KioskActivityDashboard from "../../pages/Kiosk/KioskActivityDashboard"
import ExternalCalls from "../../pages/TelerecoveryServices/ExternalCalls/index"

const routesDef = [
  {
    path: ROUTES.HOMEPAGE,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 8,
    userGroupType: 0,
    element: <generalPages.Homepage />,
  },
  {
    path: ROUTES.DASHBOARD,
    requireAdmin: true,
    leastPrivilege: 8,
    userGroupType: 0,
    element: <generalPages.Homepage />,
  },
  {
    path: ROUTES.DASHBOARD,
    requireAdmin: true,
    leastPrivilege: 8,
    userGroupType: 0,
    element: <generalPages.Homepage />,
  },
  {
    path: ROUTES.STAFF_DASHBOARD,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 9,
    userGroupType: -1,
    element: <generalPages.DashboardSupervisor />,
  },
  {
    path: ROUTES.SUPERVISOR_DASHBOARD,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 8,
    userGroupType: 0,
    element: <generalPages.DashboardSupervisor />,
  },
  {
    path: ROUTES.USERS_LIST_ADMIN,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 1,
    userGroupType: 0,
    element: <admin.UsersList />,
  },
  {
    path: ROUTES.ORGANIZATION_REPORTS,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: -1,
    element: <actions.OrganizationReports />,
  },
  {
    path: ROUTES.ORDERED_REPORTS,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: -1,
    element: <actions.OrderedReports />,
  },
  {
    path: ROUTES.DATA_DICTIONARIES,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: -1,
    element: <actions.DataDictionaries />,
  },
  {
    path: ROUTES.AUDIT_LOG,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: -1,
    element: <auditLog.AuditLog />,
  },
  {
    path: ROUTES.DEMO_PHONE_PAGE,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 8,
    userGroupType: 0,
    element: <generalPages.DemoPhonePage />,
  },
  {
    path: ROUTES.LIBRARY_ENTERPRISE_PROFILE,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <libraryPages.EnterpriseProfileLibrary />,
  },
  {
    path: ROUTES.LIBRARY_FIELDS,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <libraryPages.FieldLibrary />,
  },
  {
    path: ROUTES.LIBRARY_FIELDS_ADD,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <libraryPages.FieldAdd />,
  },
  {
    path: ROUTES.LIBRARY_FIELDS_EDIT,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <libraryPages.FieldEdit />,
  },
  {
    path: ROUTES.LIBRARY_CLONE,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <libraryPages.FieldClone />,
  },
  {
    path: ROUTES.LIBRARY_BLOCKS,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <libraryPages.BlockLibrary />,
  },
  {
    path: ROUTES.LIBRARY_GPRA,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <libraryPages.GpraConfiguration />,
  },
  {
    path: ROUTES.LIBRARY_DOCUMENT_SIGNING,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <libraryPages.DocumentsTemplateManagement />,
  },
  {
    path: ROUTES.LIBRARY_HOUSING,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <libraryPages.HouseManagement />,
  },
  {
    path: ROUTES.LIBRARY_COORDINATION_BOARDS,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <libraryPages.CoordinationBoardsConfiguration />,
  },

  {
    path: ROUTES.LIBRARY_KIOSK,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <libraryPages.KioskAdmin />,
  },
  {
    path: ROUTES.LIBRARY_ASSESSMENTS,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <libraryPages.Assessments />,
  },
  {
    path: ROUTES.COORDINATION_BOARD,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 10,
    element: <CoordinationBoards />,
  },
  {
    path: ROUTES.COORDINATION_BOARD_VIEW,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 10,
    element: <CoordinationBoards />,
  },
  {
    path: ROUTES.EXTERNAL_CALLS,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 10,
    element: <ExternalCalls />,
  },
  {
    path: ROUTES.BLOCK_CLONE,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <blocksPages.BlockClone />,
  },
  {
    path: ROUTES.BLOCK_EDIT,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <blocksPages.BlockEdit />,
  },
  {
    path: ROUTES.BLOCK_ADD,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <blocksPages.BlockAdd />,
  },
  {
    path: ROUTES.BLOCK_ASSESSMENT_ADD,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <blocksPages.BlockAssessmentAdd />,
  },
  {
    path: ROUTES.BLOCK_ASSESSMENT_CUSTOMIZE,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <blocksPages.BlockAssessmentAdd />,
  },
  {
    path: ROUTES.BLOCK_ASSESSMENT_EDIT,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <blocksPages.BlockAssessmentEdit />,
  },
  {
    path: ROUTES.TEMPLATE_EDIT,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <templatePages.TemplateEdit />,
  },
  {
    path: ROUTES.TEMPLATE_CLONE,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <templatePages.TemplateClone />,
  },
  {
    path: ROUTES.LIBRARY_TEMPLATES,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <libraryPages.TemplateLibrary />,
  },
  {
    path: ROUTES.PROGRAMS_LIST,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <programPages.ProgramsList />,
  },
  {
    path: ROUTES.ORGANIZATION_PROGRAM_LIST,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <programPages.ProgramsListOrg />,
  },
  {
    path: ROUTES.USER_LIST,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 5,
    userGroupType: 0,
    element: <user.ListUsers />,
  },
  {
    path: ROUTES.ORGANIZATION_USER_LIST,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 4,
    userGroupType: 0,
    element: <user.ListUserOrg />,
  },
  {
    path: ROUTES.ORGANIZATION_USER_LIST_FILTER,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 5,
    userGroupType: 0,
    element: <user.ListUsers />,
  },
  {
    path: ROUTES.USER_LIST_FILTER,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 5,
    userGroupType: 0,
    element: <user.ListUsers />,
  },
  // {
  //   path: ROUTES.USER_ADD,
  //   audit: false,
  //   requireAdmin: true,
  //   leastPrivilege: 5,
  //   userGroupType: 0,
  //   element: <user.AddUser />,
  // },
  // {
  //   path: ROUTES.USER_ADD_EXISTING,
  //   audit: false,
  //   requireAdmin: true,
  //   leastPrivilege: 5,
  //   userGroupType: 0,
  //   element: <user.AddExistingUser />,
  // },
  // {
  //   path: ROUTES.USER_EDIT,
  //   audit: false,
  //   requireAdmin: true,
  //   leastPrivilege: 5,
  //   userGroupType: 0,
  //   element: <user.EditUser />,
  // },
  {
    path: ROUTES.PROFILE_EDIT,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 9,
    userGroupType: 0,
    element: <user.EditProfile />,
  },
  {
    path: ROUTES.PROFILE_2FA,
    requireAdmin: false,
    leastPrivilege: 9,
    userGroupType: 0,
    element: <user.TwoFASettings />,
  },
  {
    path: ROUTES.USER_ASSIGN,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 5,
    userGroupType: 0,
    element: <user.AssignUsers />,
  },
  {
    path: ROUTES.DENIED,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 100,
    userGroupType: 0,
    element: <generalPages.PermissionDenied />,
  },
  {
    path: ROUTES.FORM_PAGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <generalPages.Form />,
  },
  {
    path: ROUTES.FORM_EDIT,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <generalPages.Form />,
  },
  {
    path: ROUTES.FORM_USER_ORG_AND_ENT_PAGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 2,
    userGroupType: 0,
    element: <generalPages.Form />,
  },
  {
    path: ROUTES.FORM_USER_ORG_AND_ENT_EDIT,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 2,
    userGroupType: 0,
    element: <generalPages.Form />,
  },
  {
    path: ROUTES.FORM_USER_ENTERPRISE_EDIT,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 2,
    userGroupType: 0,
    element: <generalPages.Form />,
  },
  {
    path: ROUTES.FORM_USER_ENTERPRISE_PAGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 2,
    userGroupType: 0,
    element: <generalPages.Form />,
  },
  {
    path: ROUTES.FORM_USER_ORGANIZATION_EDIT,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <generalPages.Form />,
  },
  {
    path: ROUTES.FORM_USER_ORGANIZATION_PAGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <generalPages.Form />,
  },
  {
    path: ROUTES.FORM_VIEW_MODE,
    audit: true,
    auditType: "dynamic",
    auditTemplateList: [
      ["ad_hoc_assessment", "participant"],
      ["ad_hoc_referral", "participant"],
      ["brief_check_in", "participant"],
      ["care_coordination_session", "participant"],
      ["custom_form_template_1", "participant"],
      ["custom_form_template_2", "participant"],
      ["custom_session_template_1", "participant"],
      ["custom_session_template_2", "participant"],
      ["document_record_participant", "participant"],
      ["document_record_staff", "staff"],
      ["form_insurance_status", "participant"],
      ["group_session", "staff"],
      ["group_supervision_session", "staff"],
      ["hep_ab_form", "participant"],
      ["hep_c_form", "participant"],
      ["housing_assistance_grant_award", "participant"],
      ["individual_supervision_session", "staff"],
      ["intake_reactivation_session", "participant"],
      ["intake_session", "participant"],
      ["lyft_assessment", "participant"],
      ["manage_services", "participant"],
      ["nicu_engagement", "participant"],
      ["note_form", "participant"],
      ["plan_self_care_engagement", "participant"],
      ["real_d_form", "participant"],
      ["recovery_plan_engagement", "participant"],
      ["staff", "staff"],
      ["general_activity_log", "organization"],
      ["harm_reduction_activity_log", "organization"],
      ["contact_log", "organization"],
      ["activity_employer_contact", "organization"],
      ["volunteer_activity_log", "organization"],
      ["harbor_care_activity_log", "organization"],
      ["pjr_activity_log", "organization"],
    ],
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <generalPages.FormViewMode />,
  },
  {
    path: ROUTES.STAFF_FORM_VIEW,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 1,
    userGroupType: 0,
    element: <generalPages.StaffFormView />,
  },
  {
    path: ROUTES.GROUP_SESSION_LIST,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <groupSessionPages.GroupSessionList />,
  },
  {
    path: ROUTES.GROUP_SUPERVISION_SESSIONS,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 4,
    userGroupType: 0,
    element: <groupSupervisionSessionsPages.GroupSupervisionSessions />,
  },
  {
    path: ROUTES.SUPERVISION_PLAN_LIST,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <supervisionPlansPages.SupervisionPlanList />,
  },
  {
    path: ROUTES.SUPERVISION_SESSION_LIST,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <supervisionSessionPages.SupervisionSessionList />,
  },
  {
    path: ROUTES.SUPERVISION_SESSION_SUPERVISOR,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 4,
    userGroupType: 0,
    element: <supervisionSessionPages.SupervisionSessionSupervisor />,
  },
  {
    path: ROUTES.SUPERVISION_SESSION_STAFF,
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <defaultPages.NotFound />,
  },
  {
    path: ROUTES.ACTIVITY_LOG_CONTACT_LOG,
    audit: true,
    auditType: "organization",
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <activityLogsPages.ContactLog />,
  },
  {
    path: ROUTES.CUSTOM_FORM_TEMPLATE_1,
    audit: true,
    auditType: "participant",
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <shelledTemplates.CustomFormTemplate1 />,
  },
  {
    path: ROUTES.CUSTOM_FORM_TEMPLATE_2,
    audit: true,
    auditType: "participant",
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <shelledTemplates.CustomFormTemplate2 />,
  },
  {
    path: ROUTES.CUSTOM_ACTIVITY_TEMPLATE_1,
    audit: true,
    auditType: "participant",
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <shelledTemplates.CustomActivityTemplate1 />,
  },
  {
    path: ROUTES.CUSTOM_ACTIVITY_TEMPLATE_2,
    audit: true,
    auditType: "participant",
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <shelledTemplates.CustomActivityTemplate2 />,
  },
  {
    path: ROUTES.CUSTOM_SESSION_TEMPLATE_1,
    audit: true,
    auditType: "participant",
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <shelledTemplates.CustomSessionTemplate1 />,
  },
  {
    path: ROUTES.CUSTOM_SESSION_TEMPLATE_2,
    audit: true,
    auditType: "participant",
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <shelledTemplates.CustomSessionTemplate2 />,
  },
  {
    path: ROUTES.ACTIVITY_LOG_GENERAL,
    audit: true,
    auditType: "organization",
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <activityLogsPages.GeneralActivityLog />,
  },
  {
    path: ROUTES.ACTIVITY_LOG_HARM_REDUCTION,
    audit: true,
    auditType: "organization",
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <activityLogsPages.HarmReductionActivityLog />,
  },
  {
    path: ROUTES.ACTIVITY_LOG_EMPLOYER_CONTACT,
    audit: true,
    auditType: "organization",
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <activityLogsPages.EmployerContactLog />,
  },
  {
    path: ROUTES.ACTIVITY_LOG_VOLUNTEER,
    audit: true,
    auditType: "organization",
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <activityLogsPages.VolunteerActivityLog />,
  },
  {
    path: ROUTES.ACTIVITY_LOG_GENERAL,
    audit: true,
    auditType: "organization",
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <activityLogsPages.GeneralActivityLog />,
  },
  {
    path: ROUTES.ACTIVITY_LOG_HARBOR_CARE,
    audit: true,
    auditType: "organization",
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <activityLogsPages.HarborCare />,
  },
  {
    path: ROUTES.ACTIVITY_LOG_PJR,
    audit: true,
    auditType: "organization",
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <activityLogsPages.PJR />,
  },
  {
    path: ROUTES.PARTICIPANT_ADD,
    audit: true,
    auditType: "participant",
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <participants.ParticipantAdd />,
  },
  {
    path: ROUTES.PARTICIPANT_PROFILE,
    audit: true,
    auditType: "participant",
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <participants.ParticipantProfile />,
  },
  {
    path: ROUTES.PARTICIPANT_ENGAGED_SERVICES,
    audit: true,
    auditType: "participant",
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <participants.ParticipantEngagedServices />,
  },
  {
    path: ROUTES.PARTICIPANT_ACCOUNT_INFORMATION,
    audit: true,
    auditType: "participant",
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <participants.ParticipantAccountInformation />,
  },
  {
    path: ROUTES.PARTICIPANT_MYPARTICIPANTS,
    audit: true,
    auditType: "organization",
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <participants.ParticipantHome />,
  },
  {
    path: ROUTES.PARTICIPANT_LIST,
    audit: true,
    auditType: "organization",
    requireAdmin: true,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <participants.ParticipantList />,
  },
  {
    path: ROUTES.PARTICIPANT_RECOVERY_PLAN,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <participants.RecoveryPlan />,
  },
  {
    path: ROUTES.PARTICIPANT_RECOVERY_CAPITAL,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <participants.RecoveryCapital />,
  },
  {
    path: ROUTES.PARTICIPANT_ASSESSMENTS,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <participants.ParticipantAssessments />,
  },
  {
    path: ROUTES.PARTICIPANT_ENGAGEMENTS_HOMEPAGE,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <participants.Engagements />,
  },
  {
    path: ROUTES.PARTICIPANT_ENGAGEMENTS_BRIEF_C,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <participants.BriefCheckIn />,
  },
  {
    path: ROUTES.PARTICIPANT_ENGAGEMENTS_MANAGE_SERVICES,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <participants.ManageServices />,
  },
  {
    path: ROUTES.PARTICIPANT_ENGAGEMENTS_MANAGE_SERVICES_EPISODES,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <participants.ServiceEpisodes />,
  },
  {
    path: ROUTES.PARTICIPANT_ENGAGEMENTS_MANAGE_SERVICES_EPISODE,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <participants.ServiceEpisode />,
  },
  {
    path: ROUTES.PARTICIPANT_ENGAGEMENTS_CARE_C,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <participants.CareCoordination />,
  },
  {
    path: ROUTES.PARTICIPANT_ENGAGEMENTS_RECOVERY_PLANNING_SESSION,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <participants.RecoveryPlanningSession />,
  },
  {
    path: ROUTES.PARTICIPANT_ENGAGEMENTS_PLAN_SELF_CARE,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <participants.PlanSelfCare />,
  },
  {
    path: ROUTES.PARTICIPANT_ENGAGEMENTS_NICU,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <participants.NICU />,
  },
  {
    path: ROUTES.PARTICIPANT_DOCUMENTS,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <participants.ParticipantDocumentManagement />,
  },
  {
    path: ROUTES.PARTICIPANT_REFERRALS,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <participants.Referrals />,
  },
  {
    path: ROUTES.NOTES_LIST,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <participants.NotesManagement />,
  },
  {
    path: ROUTES.PARTICIPANT_REFERRAL_ADD,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 7,
    element: <referralsPages.Referrals />,
  },
  {
    path: ROUTES.PARTICIPANT_REFERRAL_EDIT,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 7,
    element: <referralsPages.Referrals />,
  },
  {
    path: ROUTES.PARTICIPANT_REFERRAL_ENTITIES,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 7,
    element: <referralsPages.Referrals />,
  },
  {
    path: ROUTES.PARTICIPANT_REFERRAL_ENTITIES_ADD,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 7,
    element: <referralsPages.Referrals />,
  },
  {
    path: ROUTES.PARTICIPANT_REFERRAL_ENTITIES_EDIT,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 7,
    element: <referralsPages.Referrals />,
  },
  {
    path: ROUTES.PARTICIPANT_CUSTOM_DF_HEP_AB,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <customDataFormPages.HepAB />,
  },
  {
    path: ROUTES.PARTICIPANT_CUSTOM_DF_HEP_C,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <customDataFormPages.HepC />,
  },
  {
    path: ROUTES.PARTICIPANT_CUSTOM_DF_REAL_D,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <customDataFormPages.RealD />,
  },
  {
    path: ROUTES.PARTICIPANT_CUSTOM_DF_REAL_LYFT_ASSESSMENT,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <customDataFormPages.LyftAssessment />,
  },

  {
    path: ROUTES.PARTICIPANT_CUSTOM_DF_AD_HOC_8,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <customDataFormPages.AdHoc8Dimensions />,
  },

  {
    path: ROUTES.PARTICIPANT_CUSTOM_DF_HOUSING_ASSISTNACE,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <customDataFormPages.HousingAssistance />,
  },
  {
    path: ROUTES.PARTICIPANT_CUSTOM_DF_INSURANCE_STATUS,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 7,
    userGroupType: 0,
    element: <customDataFormPages.InsuranceStatus />,
  },

  {
    path: ROUTES.PARTICIPANT_DISCHARGE,
    audit: true,
    auditType: "participant",
    requireAdmin: true,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <participants.Discharge />,
  },
  {
    path: ROUTES.DEMO_PAGE,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <generalPages.DemoPage />,
  },
  {
    path: ROUTES.PARTNER_ENTITY_PROFILE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 9,
    userGroupType: 2,
    element: <partnerPages.ReferralEntityProfile />,
  },
  {
    path: ROUTES.PARTNER_ENTITY_STAFF,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 9,
    userGroupType: 2,
    element: <partnerPages.ReferralEntityUserList />,
  },
  {
    path: ROUTES.PARTNER_ENTITY_ADD_STAFF,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 9,
    userGroupType: 2,
    element: <partnerPages.ReferralEntityUserAdd />,
  },
  {
    path: ROUTES.PARTNER_ENTITY_EDIT_STAFF,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 9,
    userGroupType: 3,
    element: <user.EditUser />,
  },
  {
    path: ROUTES.REFERRALS_LIST,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 10,
    userGroupType: 2,
    element: <referralsPages.Referrals />,
  },
  {
    path: ROUTES.REFERRAL_EDIT,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 10,
    userGroupType: 2,
    element: <referralsPages.Referrals />,
  },

  {
    path: ROUTES.REFERRAL_ENTITIES,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 9,
    element: <referralsPages.Referrals />,
  },
  {
    path: ROUTES.REFERRAL_ENTITY_ADD,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 9,
    element: <referralsPages.Referrals />,
  },
  {
    path: ROUTES.REFERRAL_ENTITY_EDIT,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 9,
    element: <referralsPages.Referrals />,
  },
  {
    path: ROUTES.REFERRAL_ENTITY_MAP,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <partnerPages.ReferralEntitySearch />,
  },
  {
    path: ROUTES.REFERRAL_ENTITY_USER_ADD,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <partnerPages.ReferralEntityUserAdd />,
  },
  {
    path: ROUTES.REFERRAL_ENTITY_USER_EDIT,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <partnerPages.ReferralEntityUserEdit />,
  },

  {
    path: ROUTES.REFERRALS,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <referralsPages.Referrals />,
  },
  {
    path: ROUTES.REFERRAL_ADD,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <referralsPages.Referrals />,
  },
  {
    path: ROUTES.REFERRAL_NETWORKS,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 6,
    element: <referralsPages.ReferralPartnerList />,
  },
  {
    path: ROUTES.REFERRAL_NETWORK_ORG,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 6,
    element: <referralsPages.ReferralPartnerList />,
  },
  {
    path: ROUTES.ORGANIZATION_LOCATIONS_LIST,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <locationPages.LocationsListOrg />,
  },
  {
    path: ROUTES.LOCATIONS_LIST,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <locationPages.LocationsList />,
  },
  {
    path: ROUTES.ORGANIZATIONS_LIST,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <organizationPages.OrganizationsList />,
  },
  {
    path: ROUTES.ORGANIZATIONS_LIST_DEFAULT,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <organizationPages.OrganizationsList />,
  },
  {
    path: ROUTES.ORGANIZATIONS_LIST_FILTER,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <organizationPages.OrganizationsList />,
  },
  {
    path: ROUTES.ORGANIZATION_ADD,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <organizationPages.AddOrganization />,
  },
  {
    path: ROUTES.ORGANIZATION_EDIT,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <organizationPages.EditOrganization />,
  },
  {
    path: ROUTES.ORGANIZATION_STAFF,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <organizationPages.OrganizationStaff />,
  },
  {
    path: ROUTES.ENTERPRISES_LIST,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 2,
    userGroupType: 0,
    element: <enterprisePages.EnterprisesList />,
  },
  {
    path: ROUTES.ENTERPRISE_ADD,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 1,
    userGroupType: 0,
    element: <enterprisePages.AddEnterprise />,
  },
  {
    path: ROUTES.ENTERPRISE_EDIT,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 2,
    userGroupType: 0,
    element: <enterprisePages.EditEnterprise />,
  },
  {
    path: ROUTES.MY_CALENDAR,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 2,
    userGroupType: 0,
    element: <calendarPages.MyCalendar />,
  },
  {
    path: ROUTES.ORGANIZATION_CALENDAR,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 2,
    userGroupType: 0,
    element: <calendarPages.OrganizationCalendar />,
  },
  {
    path: ROUTES.STAFF_SCHEDULING,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 2,
    userGroupType: 0,
    element: <calendarPages.StaffScheduling />,
  },
  {
    path: ROUTES.STAFF_DOCUMENTS,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 4,
    userGroupType: 0,
    element: <staff.StaffDocumentManagement />,
  },
  {
    path: ROUTES.MY_APPOINTMENTS,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 2,
    userGroupType: 0,
    element: <appointmentsPages.MyAppointments />,
  },
  {
    path: ROUTES.APPOINTMENTS,
    audit: true,
    auditType: "participant",
    requireAdmin: false,
    leastPrivilege: 2,
    userGroupType: 0,
    element: <appointmentsPages.Appointments />,
  },
  {
    path: ROUTES.PARTICIPANT_TELERECOVERY_SERVICES + "/:type",
    audit: true,
    auditType: "participant",
    requireAdmin: false,
    leastPrivilege: 7,
    element: <participants.TelerecoveryServices />,
  },
  {
    path: ROUTES.TELERECOVERY_GLOBAL_MESSAGES,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 10,
    element: <GlobalMessages />,
  },
  {
    path: ROUTES.LIBRARY_TELERECOVERY,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <libraryPages.TelerecoveryConfiguration />,
  },
  {
    path: ROUTES.LIBRARY_TELERECOVERY_ORG,
    audit: false,
    requireAdmin: true,
    leastPrivilege: 3,
    userGroupType: 0,
    element: <libraryPages.TelerecoveryConfiguration />,
  },
  {
    path: ROUTES.PARTICIPANT_EMPLOYMENT_SERVICES,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 11,
    element: <participants.EmploymentIndex />,
  },
  {
    path: ROUTES.PARTICIPANT_EMPLOYMENT_CAREER,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 7,
    element: <participants.Career />,
  },
  {
    path: ROUTES.ENTERPRISE_STAFF_PROFILE,
    requireAdmin: false,
    leastPrivilege: 6,
    element: <staff.StaffProfile />,
  },
  {
    path: ROUTES.ORGANIZATION_STAFF_PROFILE,
    audit: true,
    auditType: "staff",
    requireAdmin: false,
    leastPrivilege: 6,
    element: <staff.StaffProfile />,
  },
  {
    path: ROUTES.ORGANIZATION_STAFF_SUPERVISION_PLAN,
    audit: true,
    auditType: "staff",
    requireAdmin: false,
    leastPrivilege: 6,
    landing: true,
    element: <staff.StaffPlan />,
  },
  {
    path: ROUTES.ORGANIZATION_STAFF_INDIVIDUAL_SESSION,
    audit: true,
    auditType: "staff",
    requireAdmin: false,
    leastPrivilege: 6,
    landing: true,
    element: <staff.StaffIndividualSession />,
  },
  {
    path: ROUTES.ORGANIZATION_STAFF_GROUP_SESSION,
    audit: true,
    auditType: "staff",
    requireAdmin: false,
    leastPrivilege: 6,
    landing: true,
    element: <staff.StaffGroupSession />,
  },
  {
    path: ROUTES.ORGANIZATION_STAFF_DOCUMENTS,
    audit: true,
    auditType: "staff",
    requireAdmin: false,
    leastPrivilege: 6,
    landing: true,
    element: <staff.StaffDocuments />,
  },
  {
    path: ROUTES.KIOSK_DASHBOARD,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 5,
    userGroupType: 0,
    element: <KioskActivityDashboard />,
  },
  {
    path: ROUTES.ACCOUNT_PREFERENCES,
    requireAdmin: false,
    leastPrivilege: 6,
    userGroupType: 0,
    element: <account.Preferences />,
  },
]
const gpraRoutesDef = [
  {
    path: ROUTES.PARTICIPANT_GPRA_FORMS,
    audit: true,
    auditType: "participant",
    requireAdmin: false,
    leastPrivilege: 7,
    landing: true,
    element: <GPRAForms />,
  },
  {
    path: ROUTES.GPRA_RECORDMGMT,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <RecordMgmt />,
  },
  {
    path: ROUTES.GPRA_FOLLOWUP_START,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <Start />,
  },
  {
    path: ROUTES.GPRA_DISCHARGE_START,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <Start />,
  },
  {
    path: ROUTES.GPRA_PLANNED_SERVICES1_INTAKE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <PlannedServices1Container />,
  },
  {
    path: ROUTES.GPRA_PLANNED_SERVICES1_FOLLOWUP,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <PlannedServices1Container />,
  },
  {
    path: ROUTES.GPRA_PLANNED_SERVICES1_DISCHARGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <PlannedServices1Container />,
  },
  {
    path: ROUTES.GPRA_PLANNED_SERVICES2_INTAKE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <PlannedServices2Container />,
  },
  {
    path: ROUTES.GPRA_PLANNED_SERVICES2_FOLLOWUP,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <PlannedServices2Container />,
  },
  {
    path: ROUTES.GPRA_PLANNED_SERVICES2_DISCHARGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <PlannedServices2Container />,
  },
  {
    path: ROUTES.GPRA_PLANNED_SERVICES3_INTAKE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <PlannedServices3Container />,
  },
  {
    path: ROUTES.GPRA_PLANNED_SERVICES3_FOLLOWUP,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <PlannedServices3Container />,
  },
  {
    path: ROUTES.GPRA_PLANNED_SERVICES3_DISCHARGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <PlannedServices3Container />,
  },
  {
    path: ROUTES.GPRA_PLANNED_SERVICES4_INTAKE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <PlannedServices4Container />,
  },
  {
    path: ROUTES.GPRA_PLANNED_SERVICES4_FOLLOWUP,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <PlannedServices4Container />,
  },
  {
    path: ROUTES.GPRA_PLANNED_SERVICES4_DISCHARGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <PlannedServices4Container />,
  },
  {
    path: ROUTES.GPRA_DEMOGRAPHICS_INTAKE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <DemographicsContainer />,
  },
  {
    path: ROUTES.GPRA_SUBSTANCE_USE1_INTAKE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <SubstanceUse1Container />,
  },
  {
    path: ROUTES.GPRA_SUBSTANCE_USE1_FOLLOWUP,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <SubstanceUse1Container />,
  },
  {
    path: ROUTES.GPRA_SUBSTANCE_USE1_DISCHARGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <SubstanceUse1Container />,
  },
  {
    path: ROUTES.GPRA_SUBSTANCE_USE2_INTAKE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <SubstanceUse2Container />,
  },
  {
    path: ROUTES.GPRA_SUBSTANCE_USE2_FOLLOWUP,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <SubstanceUse2Container />,
  },
  {
    path: ROUTES.GPRA_SUBSTANCE_USE2_DISCHARGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <SubstanceUse2Container />,
  },
  {
    path: ROUTES.GPRA_SUBSTANCE_USE3_INTAKE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <SubstanceUse3Container />,
  },
  {
    path: ROUTES.GPRA_SUBSTANCE_USE3_FOLLOWUP,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <SubstanceUse3Container />,
  },
  {
    path: ROUTES.GPRA_SUBSTANCE_USE3_DISCHARGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <SubstanceUse3Container />,
  },
  {
    path: ROUTES.GPRA_FAMILY_INTAKE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <FamilyContainer />,
  },
  {
    path: ROUTES.GPRA_FAMILY_FOLLOWUP,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <FamilyContainer />,
  },
  {
    path: ROUTES.GPRA_FAMILY_DISCHARGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <FamilyContainer />,
  },
  {
    path: ROUTES.GPRA_EDUCATION_INTAKE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <EducationContainer />,
  },
  {
    path: ROUTES.GPRA_EDUCATION_FOLLOWUP,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <EducationContainer />,
  },
  {
    path: ROUTES.GPRA_EDUCATION_DISCHARGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <EducationContainer />,
  },
  {
    path: ROUTES.GPRA_LEGAL_INTAKE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <LegalContainer />,
  },
  {
    path: ROUTES.GPRA_LEGAL_FOLLOWUP,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <LegalContainer />,
  },
  {
    path: ROUTES.GPRA_LEGAL_DISCHARGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <LegalContainer />,
  },
  {
    path: ROUTES.GPRA_MENTAL_INTAKE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <MentalContainer />,
  },
  {
    path: ROUTES.GPRA_MENTAL_FOLLOWUP,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <MentalContainer />,
  },
  {
    path: ROUTES.GPRA_MENTAL_DISCHARGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <MentalContainer />,
  },
  {
    path: ROUTES.GPRA_SOCIAL_INTAKE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <SocialContainer />,
  },
  {
    path: ROUTES.GPRA_SOCIAL_FOLLOWUP,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <SocialContainer />,
  },
  {
    path: ROUTES.GPRA_SOCIAL_DISCHARGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <SocialContainer />,
  },
  {
    path: ROUTES.GPRA_PROGRAM_QUESTIONS_FOLLOWUP,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <ProgramQuestionsContainer />,
  },
  {
    path: ROUTES.GPRA_PROGRAM_QUESTIONS_DISCHARGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <ProgramQuestionsContainer />,
  },
  {
    path: ROUTES.GPRA_FOLLOWUP_FOLLOWUP,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <FollowUpContainer />,
  },
  {
    path: ROUTES.GPRA_DISCHARGE_DISCHARGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <DischargeContainer />,
  },
  {
    path: ROUTES.GPRA_SERVICESRECEIVED1_DISCHARGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <ServicesReceived1Container />,
  },
  {
    path: ROUTES.GPRA_SERVICESRECEIVED2_DISCHARGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <ServicesReceived2Container />,
  },
  {
    path: ROUTES.GPRA_SERVICESRECEIVED3_DISCHARGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <ServicesReceived3Container />,
  },
  {
    path: ROUTES.GPRA_SERVICESRECEIVED4_DISCHARGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <ServicesReceived4Container />,
  },
  {
    path: ROUTES.GPRA_SERVICESRECEIVED5_DISCHARGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <ServicesReceived5Container />,
  },
  {
    path: ROUTES.GPRA_SUMMARY_INTAKE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <Summary />,
  },
  {
    path: ROUTES.GPRA_SUMMARY_FOLLOWUP,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <Summary />,
  },
  {
    path: ROUTES.GPRA_SUMMARY_DISCHARGE,
    audit: false,
    requireAdmin: false,
    leastPrivilege: 8,
    element: <Summary />,
  },
]
export { routesDef, gpraRoutesDef }
